var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.65517,
    fill: "#2F7D32",
    stroke: "white",
    strokeWidth: 0.689655
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0173 12.7896L5.31455 10.0869C5.18522 9.95759 5.00983 9.88496 4.82696 9.88496C4.64409 9.88496 4.4687 9.95759 4.33937 10.0869C4.21008 10.2162 4.13745 10.3916 4.13745 10.5745C4.13745 10.7573 4.21008 10.9327 4.33937 11.0621L7.04213 13.7648C7.17022 13.8929 7.3223 13.9946 7.48968 14.0639C7.65706 14.1333 7.83647 14.169 8.01765 14.169C8.19883 14.169 8.37824 14.1333 8.54562 14.0639C8.713 13.9946 8.86508 13.8929 8.99317 13.7648L15.3739 7.38412C15.5031 7.25479 15.5758 7.07941 15.5758 6.89654C15.5758 6.71367 15.5031 6.53828 15.3739 6.40895C15.2445 6.27966 15.0691 6.20703 14.8863 6.20703C14.7034 6.20703 14.528 6.27966 14.3987 6.40895L8.0173 12.7896Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.fb154ffc7dcc482773163ff5552bd6c3.svg";
export { ForwardRef as ReactComponent };